export const defaultMedia = ['1280', '1024', '768', '375', '320'];
